import React from 'react';
import Heatmap from '../../components/Heatmap';
import TimeCard from './TimeCard';

const ResultsList = ({ result, heatmapData, timezone, handleClear, handleSaveToJson }) => {
  return (
    <div className="results-screen" data-testid="resultsList-container">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">Analysis for r/{result?.subreddit}</h2>
      </div>
      <p>{result?.analysis?.summary}</p>

      <Heatmap heatmapData={heatmapData} timezone={timezone} />

      {result?.analysis?.peak_times && result.analysis.peak_times.length > 0 && (
        <>
          <h4 className="text-lg font-bold text-[#022B3A] dark:text-[#FFFFFF] mt-8 mb-4">Primary Posting Windows</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {result?.analysis?.peak_times?.map((time, index) => (
              <TimeCard key={index} time={time} />
            ))}
          </div>
        </>
      )}

      {result?.analysis?.shoulder_times && result.analysis.shoulder_times.length > 0 && (
        <>
          <h4 className="text-lg font-bold text-[#022B3A] dark:text-[#FFFFFF] mt-8 mb-4">Secondary Opportunities</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {result.analysis.shoulder_times.map((time, index) => (
              <TimeCard key={index} time={time} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ResultsList;
